<script setup lang="ts">
defineSlots<{
  departure(): void;
  departureLine(): void;
  stopoverInfo(): void;
  arrivalLine(): void;
  arrival(): void;
}>();
</script>

<template>
  <div class="flex w-full items-center">
    <slot name="departure" />

    <slot name="departureLine">
      <UiCustomSeparatorLine
        width-class="flex-1"
        color-class="bg-gray-300"
        class="mx-2"
        aria-hidden="true"
      />
    </slot>

    <slot name="stopoverInfo" />

    <slot name="arrivalLine">
      <UiCustomSeparatorLine
        width-class="flex-1"
        color-class="bg-gray-300"
        class="mx-2"
        aria-hidden="true"
      />
    </slot>

    <slot name="arrival" />
  </div>
</template>
